<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_fire_terminal'
      params>
      <div>
        <span class='left-table'>终端编号：</span>
        <el-input v-model='id' placeholder='请输入终端编号' style='width: 200px;'></el-input>
        <span class='left-table'>
                  <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
                </span>
<!--        <span class='left-table'>-->
<!--           <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>增加</el-button>-->
<!--        </span>-->
      </div>
    </icare-table>
    <!-- 编辑 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' width='50%' @closed='closeDialog'>

      <el-form label-width='120px' ref='form' :rules='rules' :model='form'>
        <el-form-item label='终端编号' v-if='!isEdit' prop='id'>
          <el-input t v-model='form.id' placeholder='请输入终端编号' style='width: 100%'></el-input>
        </el-form-item>
        <el-form-item label='终端名称' prop='name'>
          <el-input t v-model='form.name' placeholder='请输入终端名称' style='width: 100%'></el-input>
        </el-form-item>
        <el-form-item label='所在地址' prop='address'>
          <el-input t v-model='form.address' placeholder='请输入所在地址' style='width: 100%'></el-input>
        </el-form-item>
      </el-form>

      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeDialog'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='save'>确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'

export default {
  data() {

    return {
      loading: false,
      tableParams: {
        id: null
      },
      tableData: [],
      // pagination: {
      //   page_size: 28, //页面数据条数
      //   page_no: 1, //页号
      //   count: 30
      // },
      //编辑框信息
      editTip: '',
      editVisible: false,
      isEdit: false,
      id:null,
      titleConfig: [
        {
          field: 'id',
          title: '终端编号',
          visible: true
        },
        {
          field: 'name',
          title: '终端名称',
          visible: true
        },
        {
          field: 'address',
          title: '安装地址',
          visible: true
        },
        {
          field: 'stat',
          title: '设备状态',
          visible: true,
          fuc: function(title, item, row) {
             var s=''
            if((row.stat& 0x0001)>0){
              s+= '<div style="color:#F56C6C">消防红色指示灯亮</div>'
            }

            if((row.stat& 0x0002)>0){
              s+= '<div style="color:#F56C6C">消防绿色指示灯亮</div>'
            }
            if((row.stat& 0x0004)>0){
              s+= '<div style="color:#F56C6C">消防黄色指示灯亮</div>'
            }
            if((row.stat& 0x0100)>0){
              s+= '<div style="color:#F56C6C">按下急停按钮</div>'
            }
            return s
          }
        },
        {
          field: 'com',
          title: '串口通信',
          visible: true,
          fuc: function(title, item, row) {
            return   row.com==0 ? '<div style="color:#67C23A">正常</div>' :'<div style="color:#F56C6C">故障</div>'
          }
        },
        {
          field: 'ip',
          title: '内网IP',
          visible: true
        },
        {
          field: 'updated_at',
          title: '更新时间',
          visible: true
        },
        {
          field: 'created_at',
          title: '创建时间',
          visible: true
        },
        {
          field: 'updated_at',
          title: '是否在线',
          visible: true,
          fuc: function(title, item, row) {
              return   (new Date().getTime() - new Date(row.updated_at).getTime())/1000<=120 ? '<div style="color:#67C23A">在线</div>' :'<div style="color:#F56C6C">离线</div>'
          }
        },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '编辑',
              color: '#67C23A',
              icon: 'el-icon-edit-outline',
              fuc: this.showEdit
            },
            {
              title: '删除',
              icon: 'el-icon-delete',
              color: '#F56C6C',
              fuc: this.delete
            }
          ]
        }
      ],
      rules: {
        // id: [
        //   { required: true, message: '请输入终端编号', trigger: 'blur' },
        //   { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        // ],
        name: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        address: [
          { max: 64, message: '输入的文字过长，长度应在 64 个字符内', trigger: 'blur' }
        ]
      },
      form: {
        id: 0
      },
      formLabelWidth: '100px',
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {

  },
  methods: {
    //弹出编辑(新增)对话框
    showAdd() {
      this.isEdit = false
      this.editVisible = true
      this.editTip = '新增信息'
      this.form = Object.assign({})
    },

    //弹出编辑(新增)对话框
    showEdit(row) {
      this.isEdit = true
      this.editTip = '编辑信息'
      this.editVisible = true
      this.form = Object.assign({}, row)
    },
    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.form = {}
    },
    //模糊搜索
    find() {
      this.tableParams.id = parseInt(this.id)
      this.$refs.table.refresh()
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_fire_terminal',
          params: str
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    save() {

      let _this = this
      this.$refs.form.validate(valid => {
        if (valid) {

          var params = {}

          if (this.isEdit) {
            params = {
              id: this.form.id ,
              name: this.form.name,
              address: this.form.address,
            }
          } else {
              params = this.form
          }
          gateway({
            func: _this.isEdit == true ? 'set_fire_terminal' : 'create_fire_terminal',
            params: JSON.stringify(params)
          }).then(res => {
            if (res.code === 0) {
              if (this.isEdit) {
                this.$message.success('编辑成功')
              } else {
                this.$message.success('新增成功')
              }
              this.closeDialog()
              this.$refs.table.refresh()
            } else {
              this.$message.warning(res.msg)
            }
          })

        } else {
          return false
        }
      })
    },

    diffDate(start) {
      return new Date().getTime() - new Date(start).getTime()
    }
  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

.amap-demo {
  height: 400px;
}
</style>
